import { IResponse, requestMachine } from "@/requests/requestMachine";
import {
  AmoNotificationsApi,
  NotificationsReadBody,
  NotificationsRequestParams,
} from "../mainApi/apis/AmoNotificationsApi";
import { InlineResponse20012 } from "../mainApi/models/InlineResponse20012";

export default {
  getNotifications(
    variables?: NotificationsRequestParams
  ): Promise<IResponse<InlineResponse20012>> {
    return requestMachine<InlineResponse20012, NotificationsRequestParams>(
      AmoNotificationsApi,
      "getNotifications",
      true,
      variables
    );
  },
  readNotifications(
    variables?: NotificationsReadBody
  ): Promise<IResponse<InlineResponse20012>> {
    return requestMachine<InlineResponse20012, NotificationsReadBody>(
      AmoNotificationsApi,
      "readNotifications",
      true,
      variables
    );
  },
};
